const le = (a, b) => a <= b;
export default le;
